import React from 'react';
import styles from "../add-edit-product.scss";
import ProgressSvgComponent from "./ProgressSvgComponent";

export const NudgePrice = (payload) => {
  const { toggleIndex , productData } = payload;
  const Component = <ProgressSvgComponent 
    text={'Add Pricing Details to Get More Relevant Leads'} 
    styleParent={styles['marginY16']+' '+styles['price-nudge']+' '+styles['marginTop5']}
    />
  if(!productData.priceObj && !Array.isArray(productData)){
    return Component;
  }
  switch (toggleIndex) {
    case 1:{
      switch (true) {
        case !Number(productData.priceObj?.singlePrice):
          return Component;

        default:
          return <></>;
      }
    }
  
    case 2: {
      const minPrice = Number(productData.priceObj?.minPrice);
      const maxPrice = Number(productData.priceObj?.maxPrice);
      switch(true){
        case !minPrice && !maxPrice: 
          return Component;

        default:
          return <></>;
      }
    }
    case 3:{
      switch(true){
        case !Number(productData.priceObj?.singlePrice): 
          return Component;

        default:
          return <></>;
      }
    }
    case 4: {
      const isPrice = productData.some(item => ((item.hasOwnProperty("actualPrice") && item.actualPrice !== "") || (item.hasOwnProperty("discPrice") && item.discPrice !== "")))
      if (!isPrice) {
        return Component;
      } else {
        return <></>;
      }
    }
    default:
      return <></>;
  }
}